import { type IsMarkdownModeQuery$data } from './__generated__/IsMarkdownModeQuery.graphql.ts';

export const getIsMarkdownModeFromData = (
	data: IsMarkdownModeQuery$data | null | undefined,
): boolean => {
	return data?.content?.nodes?.[0]?.contentProperties?.latest?.isMarkdownMode ?? false;
};
